import { BaseService } from "../../core/baseService";
import { ApiResult } from "../../core/types";
import {
  HotelWifiConfigurationDto,
  UpdateWifiConfigurationDto,
} from "../types/wifi.types";

export class WifiService extends BaseService {
  async getWifiConfiguration(): Promise<ApiResult<HotelWifiConfigurationDto>> {
    return this.handleRequest<HotelWifiConfigurationDto>(
      this.client.get("/api/admin/wifi/configuration"),
    );
  }

  async updateWifiConfiguration(
    data: UpdateWifiConfigurationDto,
  ): Promise<ApiResult<HotelWifiConfigurationDto>> {
    return this.handleRequest<HotelWifiConfigurationDto>(
      this.client.put("/api/admin/wifi/configuration", data),
    );
  }
}
